import React, { useEffect, useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { LoadingMask } from "components/Common/LoadingMask";
import LoginForm from "pages/Login/LoginForm";
import Logo from "../../images/logo.svg";
import { userAtom } from "globalAtoms";
import { useConfirmEmailChangeLinkMutation, useGetDomainGymQuery, useLazyGetPagesQuery } from "store/api/api";

const ConfirmEmailChange = () => {
	const { userId, token, gym } = useParams();
	const [headerImage, setHeaderImage] = useState(null);
	const setUser = useSetRecoilState(userAtom);
	const [confirmEmailChangeTrigger, confirmEmailChange] = useConfirmEmailChangeLinkMutation();
	const { data: domainGymData, isLoading: domainGymIsLoading, error: domainGymError } = useGetDomainGymQuery(gym);
	const [trigger, gymPagesResult, lastPromiseInfo] = useLazyGetPagesQuery(domainGymData?.id);

	useEffect(() => {
		const payload = {
			user_id: userId,
			token,
		};
		confirmEmailChangeTrigger(payload);
	}, [userId, token, confirmEmailChangeTrigger]);

	useEffect(() => {
		if (confirmEmailChange.isSuccess) {
			setUser(null);
			localStorage.removeItem("creator_jwt_token");
		}
	}, [confirmEmailChange, setUser]);

	useEffect(() => {
		if (gymPagesResult?.data) {
			const page = gymPagesResult?.data?.find((p) => p.type === "sign_up");
			setHeaderImage(page?.header_image ? { backgroundImage: `url(${page?.header_image})` } : null);
		}
	}, [trigger, gymPagesResult, lastPromiseInfo, domainGymData?.id]);

	const fetchPages = async (gymId) => {
		await trigger(gymId).unwrap();
	};

	useEffect(() => {
		if (domainGymData?.id) {
			fetchPages(domainGymData?.id);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [domainGymData]);

	const url = new URL(`/error`, window.location.origin);
	url.searchParams.append(
		"message",
		confirmEmailChange.error?.data?.message || "There was an error changing your email. Please try again."
	);
	url.searchParams.append("subdomain", gym);

	if (confirmEmailChange.isLoading) {
		return <LoadingMask />;
	}

	if (domainGymIsLoading) {
		return <LoadingMask />;
	}

	if (confirmEmailChange.error) {
		return <Navigate to={url.pathname + url.search} />;
	}

	if (!domainGymData?.id || domainGymError) {
		return <Navigate to={url.pathname + url.search} />;
	}

	return (
		<div className="sb-login__container">
			<div className="sb-login__container__form-container">
				<div className="sb-login__container__form-container__header">
					<Link to="/">
						<img className="sb-login__container__form-container__header__image-email-change" src={Logo} alt="logo" />
					</Link>

					<div className="sb-login__container__form-container__header__email-message">
						<h1 className="sb-login__container__form-container__header__email-message__title">
							Your email was successfully changed.
						</h1>
						<p className="sb-login__container__form-container__header__email-message__subtitle">
							Please login using your new email address and password
						</p>
					</div>
					<h1 className="sb-login__container__form-container__header__title">{domainGymData?.name || "Login"}</h1>
				</div>

				<LoginForm gymId={domainGymData.id} />
			</div>
			<div className="sb-login__container__image-container">
				<div className="sb-login__container__image-container__inner">
					<div className="sb-login__container__image-container__inner__image" style={headerImage} />
				</div>
			</div>
		</div>
	);
};

export default ConfirmEmailChange;

